import React, { Component } from 'react';
import { axisBottom, axisRight } from 'd3-axis';

import PropTypes from 'prop-types';
import { select } from 'd3-selection';
import styles from './grid.module.scss';
import { tickOptions } from '../../constants/chart-options';

export default class Grid extends Component{
    componentDidMount(){
        this.renderGrid();
    }

    renderGrid = () => {
        const { gridHeight, gridWidth, scale, ticks, tickValues, type } = this.props;
        const tickDimension = {
            horizontal: gridWidth,
            vertical: gridHeight,
        };
        const d3Grid = {
            horizontal: () => axisRight( scale ),
            vertical: () => axisBottom( scale )
        };

        const grid = d3Grid[type]()
            .ticks( ticks )
            .tickSize( [tickDimension[type]] )
            .tickFormat( '' );

        if( tickValues && tickValues.length ){
            // overrides .ticks() with array of explicit values
            grid.tickValues( tickValues );
        }

        select( this.gridElement ).call( grid );
    }

    render(){
        return (
            <g
                className={styles.grid}
                ref={ el => this.gridElement = el }
            />
        );
    }
}

Grid.defaultProps = {
    height: 100,
    ticks: tickOptions.X_NUM_TICKS,
    width: 100
};

Grid.propTypes = {
    gridHeight: PropTypes.number,
    gridWidth: PropTypes.number,
    scale: PropTypes.func.isRequired,
    ticks: PropTypes.number,
    tickValues: PropTypes.array,
    type: PropTypes.string.isRequired,
};
